import { useContext } from 'react';
import { NotificacionesContext } from '../contexts/NotificacionesContext';

/**
 * useNotificacionesContext - Hook personalizado para acceder al contexto de notificaciones
 *
 * Proporciona acceso fácil y seguro al estado y acciones del contexto de notificaciones
 * desde cualquier componente de la aplicación
 *
 * @returns {object} Objeto con estado y acciones del contexto
 * @throws {Error} Si se usa fuera del NotificacionesProvider
 *
 * @example
 * const { contadorNotificaciones, removerNotificacion } = useNotificacionesContext();
 *
 * // Restar una notificación
 * removerNotificacion(123);
 */
export const useNotificacionesContext = () => {
  const context = useContext(NotificacionesContext);

  if (!context) {
    throw new Error('useNotificacionesContext debe ser usado dentro de <NotificacionesProvider>');
  }

  return context;
};
